import { utils } from 'components/lexemes';
import Localization from 'lib/localization';

export default {
  tab: {
    title() {
      return Localization.get('bumblesite@privacy.usResidents.tab.title');
    },
    content() {
      return Localization.get('bumblesite@privacy.usResidents.tab.content', {
        link_privacy_policy: utils.getLinkMarkerUrl('link_privacy_policy'),
      });
    },
    listTitle() {
      return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.title');
    },
    list: [
      () => {
        return Localization.get('bumblesite@privacy.usResidents.states.ca');
      },
      () => {
        return Localization.get('bumblesite@privacy.usResidents.states.co');
      },
      () => {
        return Localization.get('bumblesite@privacy.usResidents.states.cn');
      },
      () => {
        return Localization.get('bumblesite@privacy.usResidents.states.nj');
      },
      () => {
        return Localization.get('bumblesite@privacy.usResidents.states.or');
      },
      () => {
        return Localization.get('bumblesite@privacy.usResidents.states.tx');
      },
      () => {
        return Localization.get('bumblesite@privacy.usResidents.states.ut');
      },
      () => {
        return Localization.get('bumblesite@privacy.usResidents.states.vi');
      },
    ],
  },
  section1: {
    title() {
      return Localization.get('bumblesite@privacy.usResidents.section1.title');
    },
    content() {
      return (
        Localization.get('bumblesite@privacy.usResidents.section1.content', {
          link_privacy_policy: utils.getLinkMarkerUrl('link_privacy_policy'),
        })
          // @TODO: update lexeme
          .replace('our <a href="/privacy-policy">Privacy Policy</a>', 'this Privacy Policy')
      );
    },
    goodToKnow: {
      title() {
        return Localization.get('bumblesite@privacy.goodToKnow');
      },
      content() {
        return Localization.get('bumblesite@privacy.usResidents.section1.goodToKnow.content', {
          link_contact_us: utils.getLinkMarkerUrl('link_our_contact_information'),
        });
      },
    },
  },
  usa: {
    rights: {
      item1: {
        title: () => Localization.get('bumblesite@privacy.rights.subsection3.item2.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item1.content'),
      },
      item2: {
        title: () => Localization.get('bumblesite@privacy.rights.subsection3.item3.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item2.content'),
      },
      item3: {
        title: () => Localization.get('bumblesite@privacy.rights.subsection1.item4.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item3.content'),
      },
      item4: {
        title: () => Localization.get('bumblesite@privacy.usa.rights.item4.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item4.content'),
      },
      item5: {
        title: () => Localization.get('bumblesite@privacy.usa.rights.item5.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item5.content'),
      },
      item6: {
        title: () => Localization.get('bumblesite@privacy.usa.rights.item6.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item6.content'),
      },
      item7: {
        title: () => Localization.get('bumblesite@privacy.usa.rights.item7.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item7.content'),
      },
      item8: {
        content: () => Localization.get('bumblesite@privacy.usa.rights.item8.content'),
      },
      item9: {
        title: () => Localization.get('bumblesite@privacy.usa.rights.item9.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item9.content'),
      },
      item10: {
        title: () => Localization.get('bumblesite@privacy.usa.rights.item10.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item10.content'),
      },
      item11: {
        title: () => Localization.get('bumblesite@privacy.usa.rights.item11.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item11.content'),
      },
      item12: {
        title: () => Localization.get('bumblesite@privacy.usa.rights.item12.title'),
        content: () => Localization.get('bumblesite@privacy.usa.rights.item12.content'),
      },
    },
    grid: {
      row1: {
        col1: () => Localization.get('bumblesite@privacy.usa.rights.table.row1.col1'),
        col2: () => Localization.get('bumblesite@privacy.usa.rights.table.row1.col2'),
        col3: () => Localization.get('bumblesite@privacy.usa.rights.table.row1.col3'),
      },
      row2: {
        col1: () =>
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row4.cell2'),
        col2: () =>
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row4.cell1'),
        col3: () => Localization.get('bumblesite@privacy.usa.rights.table.row2.col3'),
      },
      row3: {
        col1: () =>
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row4.1.cell2'),
        col2: () =>
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row4.1.cell1'),
        col3: () => Localization.get('bumblesite@privacy.usa.rights.table.row3.col3'),
      },
      row4: {
        col1: () =>
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row5.cell2'),
        col2: () =>
          Localization.get('bumblesite@privacy.informationSharing.subsection2.table.row5.cell1'),
        col3: () => Localization.get('bumblesite@privacy.usa.rights.table.row4.col3'),
      },
    },
    students: {
      title: () => Localization.get('bumblesite@privacy.usa.rights.students.title'),
      text1: () => Localization.get('bumblesite@privacy.usa.rights.students.text1'),
      text2: () => Localization.get('bumblesite@privacy.usa.rights.students.text2'),
      text3: () => Localization.get('bumblesite@privacy.usa.rights.students.text3'),
      text4: () => Localization.get('bumblesite@privacy.usa.rights.students.text4'),
    },
  },
  rights: [
    () => {
      return (
        `${Localization.get('bumblesite@privacy.usResidents.rights.ca', {
          privacy_url: utils.getLinkMarkerUrl('privacy_url'),
        })}${Localization.get('bumblesite@privacy.usResidents.rights.caPrivacyRights')}`
          // @TODO: update lexeme
          .replace(/<u>/g, '')
          .replace(/<\/u>/g, '')
          .replace(
            '<h5>Privacy Policy</h5> <p>You can read Bumble’s privacy policy by going to: <a href="/privacy-policy">www.bumble.com/privacy</a>.',
            '',
          )
      );
    },
    () => {
      return (
        Localization.get('bumblesite@privacy.usResidents.rights.co', {
          feedback_url: utils.getLinkMarkerUrl('feedback_url'),
        })
          // @TODO: update lexeme
          .replace(/<br>/g, '<br /><br />')
          .replace(/<u>/g, '<b>')
          .replace(/<\/u>/g, '</b>')
      );
    },
    () => {
      return (
        Localization.get('bumblesite@privacy.usResidents.rights.cn', {
          feedback_url: utils.getLinkMarkerUrl('feedback_url'),
        })
          // @TODO: update lexeme
          .replace(/<br>/g, '<br /><br />')
          .replace(/<u>/g, '<b>')
          .replace(/<\/u>/g, '</b>')
      );
    },
    () => {
      return (
        Localization.get('bumblesite@privacy.usResidents.rights.nj')
          // @TODO: update lexeme
          .replace(/<br>/g, '<br /><br />')
          .replace(/<u>/g, '<b>')
          .replace(/<\/u>/g, '</b>')
      );
    },
    () => {
      return (
        Localization.get('bumblesite@privacy.usResidents.rights.or', {
          feedback_url: utils.getLinkMarkerUrl('feedback_url'),
        })
          // @TODO: update lexeme
          .replace(/<br>/g, '<br /><br />')
          .replace(/<u>/g, '<b>')
          .replace(/<\/u>/g, '</b>')
      );
    },
    () => {
      return (
        Localization.get('bumblesite@privacy.usResidents.rights.tx', {
          feedback_url: utils.getLinkMarkerUrl('feedback_url'),
        })
          // @TODO: update lexeme
          .replace(/<br>/g, '<br /><br />')
          .replace(/<u>/g, '<b>')
          .replace(/<\/u>/g, '</b>')
      );
    },
    () => {
      return (
        Localization.get('bumblesite@privacy.usResidents.rights.ut', {
          feedback_url: utils.getLinkMarkerUrl('feedback_url'),
        })
          // @TODO: update lexeme
          .replace(/<br>/g, '<br /><br />')
          .replace(/<u>/g, '<b>')
          .replace(/<\/u>/g, '</b>')
      );
    },
    () => {
      return (
        Localization.get('bumblesite@privacy.usResidents.rights.vi', {
          feedback_url: utils.getLinkMarkerUrl('feedback_url'),
        })
          // @TODO: update lexeme
          .replace(/<br>/g, '<br /><br />')
          .replace(/<u>/g, '<b>')
          .replace(/<\/u>/g, '</b>')
          .replace(/<ul>/g, '<br /><br /><ul>')
      );
    },
  ],
};
